/* Back-in-stock notify → Klaviyo (snippets/pgs-notify-me.liquid)
   Uses XMLHttpRequest on purpose: other apps on the store wrap window.fetch
   and can drop custom headers (Klaviyo needs the 'revision' header).
   Language is saved on the profile afterwards via klaviyo.identify (bis_locale).
   After a successful signup the form is replaced by a confirmation, remembered
   per variant in localStorage so it stays after reload.
   Each .pgs-bis is initialised once (data-bis-init) - no repeated DOM writes. */
(function () {
  if (window.__pgsBisBound) return;
  window.__pgsBisBound = true;

  var EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;
  var REVISION = '2024-10-15';
  var STORE_KEY = 'pgs-bis:';

  function remember(id) { try { localStorage.setItem(STORE_KEY + id, '1'); } catch (e) {} }
  function isRemembered(id) { try { return localStorage.getItem(STORE_KEY + id) === '1'; } catch (e) { return false; } }

  function say(root, text, ok) {
    var m = root.querySelector('.pgs-bis__msg');
    if (!m) return;
    var cls = 'pgs-bis__msg ' + (ok ? 'is-ok' : 'is-err');
    if (m.textContent !== (text || '')) m.textContent = text || '';
    if (m.className !== cls) m.className = cls;
  }

  function markDone(root) {
    if (root.classList.contains('is-done')) return;
    root.classList.add('is-done');
    say(root, root.dataset.msgOk, true);
  }

  function unmarkDone(root) {
    if (!root.classList.contains('is-done')) return;
    root.classList.remove('is-done');
    say(root, '', true);
  }

  function applyState(root) {
    if (root.dataset.variant && isRemembered(root.dataset.variant)) markDone(root);
    else unmarkDone(root);
  }

  /* initialise forms that haven't been seen yet (runs once per element) */
  function initNew() {
    var list = document.querySelectorAll('.pgs-bis:not([data-bis-init])');
    for (var i = 0; i < list.length; i++) {
      list[i].setAttribute('data-bis-init', '1');
      applyState(list[i]);
    }
  }

  function post(url, payload, done) {
    var xhr = new XMLHttpRequest();
    xhr.open('POST', url, true);
    xhr.setRequestHeader('Content-Type', 'application/vnd.api+json');
    xhr.setRequestHeader('Accept', 'application/vnd.api+json');
    xhr.setRequestHeader('revision', REVISION);
    xhr.onload = function () { done(xhr.status, xhr.responseText); };
    xhr.onerror = function () { done(0, ''); };
    xhr.send(JSON.stringify(payload));
  }

  function submit(root) {
    if (!root || root.dataset.busy === '1') return;
    var input = root.querySelector('.pgs-bis__email');
    var btn = root.querySelector('.pgs-bis__btn');
    var email = (input && input.value || '').trim();
    if (!EMAIL_RE.test(email)) { say(root, root.dataset.msgInvalid, false); if (input) input.focus(); return; }
    root.dataset.busy = '1';
    if (btn) btn.disabled = true;

    var url = 'https://a.klaviyo.com/client/back-in-stock-subscriptions/?company_id=' + encodeURIComponent(root.dataset.key);
    var payload = {
      data: {
        type: 'back-in-stock-subscription',
        attributes: {
          profile: { data: { type: 'profile', attributes: { email: email } } },
          channels: ['EMAIL']
        },
        relationships: {
          variant: { data: { type: 'catalog-variant', id: '$shopify:::$default:::' + root.dataset.variant } }
        }
      }
    };

    post(url, payload, function (status, body) {
      root.dataset.busy = '';
      if (btn) btn.disabled = false;
      if (status >= 200 && status < 300) {
        remember(root.dataset.variant);
        if (input) input.value = '';
        var same = document.querySelectorAll('.pgs-bis[data-variant="' + root.dataset.variant + '"]');
        for (var i = 0; i < same.length; i++) markDone(same[i]);
        try {
          if (window.klaviyo && window.klaviyo.identify) {
            window.klaviyo.identify({ email: email, bis_locale: root.dataset.locale });
          }
        } catch (e) {}
      } else {
        console.warn('[pgs-notify] Klaviyo BIS error', status, body);
        say(root, root.dataset.msgErr, false);
      }
    });
  }

  document.addEventListener('click', function (e) {
    var open = e.target.closest && e.target.closest('.pgs-bis__open');
    if (open) {
      e.preventDefault();
      var r = open.closest('.pgs-bis');
      r.classList.add('is-open');
      var i = r.querySelector('.pgs-bis__email');
      if (i) i.focus();
      return;
    }
    var b = e.target.closest && e.target.closest('.pgs-bis__btn');
    if (b) { e.preventDefault(); submit(b.closest('.pgs-bis')); }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Enter') return;
    var t = e.target;
    if (t && t.classList && t.classList.contains('pgs-bis__email')) { e.preventDefault(); submit(t.closest('.pgs-bis')); }
  });

  /* product page: show/hide when the selected variant changes */
  function sync() {
    var roots = document.querySelectorAll('.pgs-bis[data-mode="product"]');
    for (var r = 0; r < roots.length; r++) {
      var root = roots[r];
      var avail;
      try { avail = JSON.parse(root.querySelector('.pgs-bis__avail').textContent); } catch (e) { continue; }
      var idInput = document.querySelector('form[id^="product-form-"] input[name="id"]');
      var id = (idInput && idInput.value) || new URLSearchParams(location.search).get('variant') || root.dataset.variant;
      if (!id || !(id in avail)) continue;
      if (id !== root.dataset.variant) {
        root.dataset.variant = id;
        applyState(root);
      }
      var hide = avail[id] === true;
      if (root.hidden !== hide) root.hidden = hide;
    }
  }
  document.addEventListener('change', function (e) {
    if (e.target && e.target.closest && e.target.closest('.pgs-bis')) return;
    setTimeout(sync, 60);
  });
  window.addEventListener('popstate', sync);

  /* cards added later (filters, load more, recommendations): check at most once per frame,
     and only for forms that haven't been initialised yet */
  var queued = false;
  if ('MutationObserver' in window) {
    new MutationObserver(function () {
      if (queued) return;
      queued = true;
      requestAnimationFrame(function () { queued = false; initNew(); });
    }).observe(document.body || document.documentElement, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initNew);
  else initNew();
})();
